import { render, staticRenderFns } from "./AccountStatus.vue?vue&type=template&id=5fb65d9e"
import script from "./AccountStatus.vue?vue&type=script&lang=js"
export * from "./AccountStatus.vue?vue&type=script&lang=js"
import style0 from "./AccountStatus.vue?vue&type=style&index=0&id=5fb65d9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBanner,VBtn,VCol,VContainer,VRow})
